import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import share from '@devices/settings/device_settings/share.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

export default {
	name: 'MMotorsVentora',
	friendly_name: 'MMotors Ventora',
	family: 'fan',
	isPM: true,
	modes: {
		fan: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'overpower', 'overvoltage', 'overtemperature'],
			settings: [
				schedule_gen_2,
				webhooks_gen_2,
				scripts_gen_2,
				networks_gen_2_plus,
				bluetooth_gen_2,
				{
					title: 'sensor_settings',
					components: [
						{ title: 'illuminance_settings', component: 'ventora_illuminance_settings' },
						{
							title: 'humidity_settings',
							component: 'ventora_humidity_settings',
							min_ver: '0.11.4',
						},
						{
							title: 'temperature_settings',
							component: 'ventora_temperature_settings',
							min_ver: '0.11.4',
						},
					],
				},
				{
					title: 'fan_settings',
					components: [
						{ title: 'ventora_in_mode', component: 'ventora_fan_in_mode' },
						{ title: 'ventora_run_mode', component: 'ventora_fan_run_mode' },
						{ title: 'ventora_night_mode', component: 'ventora_fan_night_mode' },
						{ title: 'ventora_idle_refresh', component: 'ventora_fan_idle_refresh' },
						{ title: 'ventora_light_trigger', component: 'ventora_fan_light_trigger' },
						{ title: 'ventora_temp_trigger', component: 'ventora_fan_temp_trigger' },
						{ title: 'ventora_hum_trigger', component: 'ventora_fan_hum_trigger' },
						{ title: 'ventora_boost_defaults', component: 'ventora_fan_boost_defaults' },
					],
				},
				{
					title: 'application_settings',
					components: [
						{
							title: 'device_card_customization',
							component: 'customize_device_content',
						},
						{
							title: 'exclude_event_log',
							component: 'exclude_event_log',
						},
					],
				},
				share,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode_g2' },
						{ title: 'device_name', component: 'device_name_g2' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'geo_location_and_time_zone', component: 'location_g2' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'factory_reset', component: 'factory_reset' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
